export default "__VITE_ASSET__DTNzhg0u__"